export default __webpack_public_path__ + "static/media/cart.c002c409.svg";